<template>
    <div class="page m-trainPlan">

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="'排班日期'">
                <el-date-picker
                    v-model="formSearch.startStamp"
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span> {{$t('c.to')}} </span>
                <el-date-picker
                    v-model="formSearch.endStamp"
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
            <el-form-item>
                <el-button type="primary"  @click="getTrainData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">
            <div class="page-operate">
                <el-button-group>
                    <el-tooltip class="item" effect="dark" :content="'添加排班'" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" @click="$router.push({name: 'addAttendance'})">
                            <i class="nucfont inuc-copy"></i>
                        </el-button>
                    </el-tooltip>

                    <!-- <el-tooltip v-if="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')" placement="top-end"
                                :hide-after="1000">
                        <el-button size="small" :title="$t('c.delete')" @click="deletePlan">
                            <i class="nucfont inuc-delete"></i>
                        </el-button>
                    </el-tooltip> -->
                </el-button-group>

            </div>

            <data-tables-server class="form-table"
                         ref="trainTable"
                         :data="tableData"
                         :total="tableDataLength"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @query-change="onPage"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <!-- <el-table-column type="selection" width="55px" :reserve-selection="true" align="center"
                                 :selectable='checkboxInit'></el-table-column> -->

                <!-- column title -->

                <el-table-column key="duration"
                                 prop="duration" :label="'排班日期'" min-width="240px" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column key="office"
                                 prop="office" :label="'科室'" align="center" show-overflow-tooltip></el-table-column>

                <el-table-column property="release" :label="'状态'" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="type-bg">{{scope.row.status==1?'已发布,待审核':scope.row.status==2?'已审核':'待发布'}}</span>
                </template>
                </el-table-column>

                <!-- column buttons -->
                <el-table-column :label="$t('c.operation')" align="center" width="150px">
                    <template v-slot="{row}">
                        <div class="btn-cell">
                            <i class="nucfont inuc-preview"
                               :title="$t('c.view')"
                               @click="viewTrainPlan(row)"></i>
                            <i :title="'克隆'"
                                   class="nucfont inuc-clone"
                                   @click="editTrainPlan(row.id,'clone',row.officeId)">
                                </i>
                            <!-- 编辑、发布、审核 -->
                            <template v-if="row.status!=2">
                                <i :title="$t('c.edit')"
                                   class="nucfont inuc-edit"
                                   @click="editTrainPlan(row.id,'edit',row.officeId)">
                                </i>
                                </template>
                                <template v-if="row.status==0">
                                <i :title="$t('c.publish')"
                                   class="nucfont inuc-publish"
                                   @click="handlePublish(row.id,row.officeId)">
                                </i>
                            </template>
                            <template v-if="row.status==1">
                                <i :title="'审核'"
                                   class="nucfont inuc-shenhe"
                                   @click="handleAudit(row.id,row.officeId)">
                                </i>
                            </template>
                            <i :title="'删除'"
                                   class="nucfont inuc-delete"
                                   @click="deletePlan(row.id,row.officeId)">
                                </i>
                        </div>
                    </template>
                </el-table-column>
            </data-tables-server>
        </div>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';

    export default {
        components: {

        },
        data() {
            return {
                userInfo: {},
                //删除相关
                isDeleteShow: false,
                //搜索条件相关
                formSearch: {
                    officeIds:[],
                    startStamp: '',
                    endStamp: ''
                },
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto",
                },
                tableDataLength: 0,
                currentPage: 1,
                pageSize: 20,
                selectPlanId: [],

            }
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }

            this.getTrainData();

        },
        computed: {

            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endStamp) return false;
                        return time.getTime() > new Date(that.formSearch.endStamp).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startStamp) return false;
                        let dateTime = new Date(that.formSearch.startStamp);
                        dateTime=dateTime.setDate(dateTime.getDate()-1);
                        return time.getTime() < new Date(dateTime).getTime()
                    },
                }
            },
        },
        methods: {
            orgsChange(data) {
                this.formSearch.officeIds = data;
            },
            onPage(q) {
                if (q.type === 'init') return
                this.currentPage = q.page
                this.pageSize = q.pageSize

                this.getTrainData()
            },
            getTrainData(page) {
                if(page) this.currentPage = page;
                let queryData = {
                    ...this.formSearch,
                    page: this.currentPage,
                    limit: this.pageSize,
                    };
                api.getTimeSheetPlan(queryData).then(res => {
                    let data = res.data.plans;
                     this.tableDataLength = res.data.count;
                      if(data){
                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].dutyStart.substring(0, 10) + " — "
                            + (data[i].dutyEnd && data[i].dutyEnd.substring(0, 10) || '');
                    }

                    this.tableData = data;
                    }else{
                        this.tableData = []
                    }
                        this.$nextTick(() => {
                            let elTable = this.$refs.trainTable.$refs.elTable
                            elTable.doLayout()
                        })
                })
            },
            handlePublish(id,officeId) {
                api.getPlanOperationAuth().then(({data}) => {
                        let index = data.operationOrgIds.findIndex(ele => ele == officeId);

                        if (index >= 0) {
                            this.$confirm('确认发布此排班计划吗？', this.$t('c.publish'), {
                    type: 'warning'
                }).then(() => {
                    api.releaseTimeSheetPlan(id).then((data) => {
                        this.getTrainData();
                    });
                }).catch(() => {});

                        } else {
                           this.$message({
                                type: 'warning',
                                message: '不属于同一科室，无权限操作此步骤!'
                            });
                        }
                    });

            },
            handleAudit(id,officeId){
                api.getPlanOperationAuth().then(({data}) => {
                        let index = data.operationOrgIds.findIndex(ele => ele == officeId);

                        if (index >= 0) {
                            this.$router.push({name: 'auditDetail',params: {attendanceId: id}})

                        } else {
                           this.$message({
                                type: 'warning',
                                message: '不属于同一科室，无权限操作此步骤!'
                            });
                        }
                    });

            },
            deletePlan(id,officeId) {
                api.getPlanOperationAuth().then(({data}) => {
                        let index = data.operationOrgIds.findIndex(ele => ele == officeId);

                        if (index >= 0) {
                            this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteTimeSheetPlan({planIds: [id]}).then((data) => {
                            this.$message({
                                type: 'success',
                                message: this.$t('m.delSuccess')
                            });
                            this.getTrainData();
                            this.isDeleteShow = false;
                            this.$refs.trainTable.$refs.elTable.clearSelection();
                        });
                }).catch(() => {
                });

                        } else {
                           this.$message({
                                type: 'warning',
                                message: '不属于同一科室，无权限操作此步骤!'
                            });
                        }
                    });

            },
            handleSelectionChange(val) {
                this.selectPlanId = [];
                val.forEach((v, k) => {
                    this.selectPlanId.push(v.id);
                });
                this.selectPlanId.length ? this.isDeleteShow = true : this.isDeleteShow = false;
            },
            checkboxInit(row) {
                return true;
            },

            viewTrainPlan(data) {
                this.$router.push({name: 'attendanceDetail',params: {attendanceId: data.id}})
            },
            editTrainPlan(id,type,officeId) {
                api.getPlanOperationAuth().then(({data}) => {
                        let index = data.operationOrgIds.findIndex(ele => ele == officeId);

                        if (index >= 0) {
                            this.$router.push({name: 'editAttendance',params: {attendanceId: id,type:type}})

                        } else {
                           this.$message({
                                type: 'warning',
                                message: '不属于同一科室，无权限操作此步骤!'
                            });
                        }
                    });

            },

            onSubpageClose() {
                if (Ticket.get()) this.getTrainData()
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .page-table {
        overflow: hidden;
        .form-table {
            overflow: hidden;
        }
    }

    .m-trainPlan {
        .survey-paper {
            & /deep/ .el-table__body-wrapper{
                height: 300px;
            }
            & /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
                box-shadow: none;
            }
        }
    }

</style>
